<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import store from './store'
export default {
  name: 'App',
  data() {
    return {
      isDarkMode: false
    }
  },
  mounted() {
    // 检查本地存储的主题设置
    const savedTheme = localStorage.getItem('theme')
    if (savedTheme) {
      this.isDarkMode = savedTheme === 'dark'
    } else {
      // 默认根据系统偏好设置
      this.isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches
    }
    this.updateTheme()
  },
  watch: {
    isDarkMode(newVal) {
      this.updateTheme()
      localStorage.setItem('theme', newVal ? 'dark' : 'light')
    }
  },
  methods: {
    updateTheme() {
      if (this.isDarkMode) {
        document.body.classList.add('dark-theme')
        document.body.classList.remove('light-theme')
      } else {
        document.body.classList.add('light-theme')
        document.body.classList.remove('dark-theme')
      }
      
      // 触发自定义事件，通知其他组件主题已更改
      const event = new CustomEvent('theme-change', { 
        detail: { theme: this.isDarkMode ? 'dark' : 'light' } 
      });
      document.dispatchEvent(event);
    },
    toggleTheme() {
      this.isDarkMode = !this.isDarkMode
    }
  }
}
</script>

<style>
#app {
  height:inherit;
  font-family:"微软雅黑","Helvetica","宋体";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* background: rgb(27,31,57); */
  background:#131417;
}
.el-menu{
  border-right:none;
}

/* 全局暗色主题样式 */
.dark-theme {
  background-color: #131417;
  color: #e3dcdc;
}

.dark-theme .el-input__inner,
.dark-theme .el-textarea__inner,
.dark-theme .el-select-dropdown,
.dark-theme .el-select-dropdown__item.hover,
.dark-theme .el-select-dropdown__item:hover,
.dark-theme .el-dropdown-menu,
.dark-theme .el-dropdown-menu__item:hover {
  background-color: #1d1f25;
  border-color: #454847;
  color: #e3dcdc;
}

.dark-theme .el-select-dropdown__item {
  color: #a9abad;
}

.dark-theme .el-card {
  background-color: #1d1f25;
  border-color: #454847;
  color: #e3dcdc;
}

.dark-theme .el-table,
.dark-theme .el-table th,
.dark-theme .el-table tr {
  background-color: #1d1f25;
  color: #e3dcdc;
}

.dark-theme .el-table--border th,
.dark-theme .el-table--border td,
.dark-theme .el-table--border::after,
.dark-theme .el-table--border .el-table__body-wrapper::after,
.dark-theme .el-table--border .el-table__header-wrapper::after {
  border-color: #454847;
}

.dark-theme .el-pagination {
  background-color: #1d1f25;
  color: #e3dcdc;
}

.dark-theme .el-dialog {
  background-color: #1d1f25;
  border-color: #454847;
}

.dark-theme .el-dialog__title {
  color: #e3dcdc;
}

/* 全局亮色主题样式 */
.light-theme {
  background-color: #eeeff2;
  /* color: #606266; */
}

.light-theme #app {
  background: #eeeff2;
}

.light-theme .el-input__inner,
.light-theme .el-textarea__inner,
.light-theme .el-select-dropdown {
  background-color: #ffffff;
  border-color: #dcdfe6;
  color: #434447;
}

.light-theme .el-card {
  background-color: #ffffff;
  border-color: #ebeef5;
  color: #434447;
}

.light-theme .el-table,
.light-theme .el-table tr {
  background-color: #ffffff;
  color: #434447;
}

.light-theme .el-pagination {
  color: #434447;
}

.light-theme .el-dialog {
  background-color: #ffffff;
  border-color: #ebeef5;
}

.light-theme .el-dialog__title {
  color: #434447;
}
</style>


// WEBPACK FOOTER //
// src/App.vue